import type { League } from "@/pages/Home/constant";
import { useHomePageStore } from "@/store";
import { cn } from "@roman/shared/utils";

type SelectLeagueProps = {
  className?: string;
  selectedLeague: League;
  activeLeaguesMap: Record<string, boolean>;
  sortedLeagues: League[];
};

export const SelectLeague: React.FC<SelectLeagueProps> = ({ selectedLeague, sortedLeagues, activeLeaguesMap }) => {
  const setSelectedLeague = useHomePageStore((state) => state.setSelectedLeague);

  return (
    <div className="flex overflow-x-scroll hide-scrollbar bg-light-blue mt-[15px] p-2 gap-2 border-b border-solid border-secondary">
      {sortedLeagues.map((league) => {
        const isSelected = league.seasonId === selectedLeague.seasonId;
        const isActive = activeLeaguesMap[league.seasonId] || false;
        return (
          <div
            key={league.seasonId}
            className={cn(
              "text-nowrap px-2 py-[2px] text-sm hover:cursor-pointer rounded-full border border-[#808080]",
              isActive ? "border-primary" : "",
              isSelected ? "bg-primary" : "bg-white",
            )}
            onMouseDown={() => {
              setSelectedLeague(league);
            }}
          >
            <div className="flex items-center py-[2px] gap-1">
              {isActive && (
                <span className={cn("relative flex h-[7px] w-[7px]")}>
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#4AFFFC] opacity-75" />
                  <span
                    className={cn("border border-none relative inline-flex rounded-full h-[7px] w-[7px] bg-[#4AFFFC]")}
                  />
                </span>
              )}

              <span
                className={cn(
                  "text-xs",
                  isActive ? "text-primary font-bold" : "",
                  isSelected ? "text-white font-bold" : "",
                )}
              >
                {league.name}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};
